import { all, put, select, takeLatest } from 'redux-saga/effects'
import * as CestaActions from '../../../../common/context/actions/cestaActions'
import { DataSteps, Steps } from '../../../../common/components/cesta/Steps'
import { navigate } from 'gatsby'
import * as PermutarNeumaticosActions from './permutarNeumaticosActions'
import { selectPermutarNeumaticos } from './permutarNeumaticosSelectors'
import { PermutarNeumaticosState } from './permutarNeumaticosReducer'
import { CocheTypeEnum } from '../cocheType.d'

const ID_NAVISION_PERMUTAR_TURISMO = '95140'
const ID_NAVISION_PERMUTAR_OTHERS = '95141'

function* addPermutarNeumaticosCesta() {
  const state = yield select()
  const pnState: PermutarNeumaticosState = yield selectPermutarNeumaticos(state)
  const { matricula, vehicle } = pnState
  yield put(CestaActions.addMatricula(matricula))

  const idNavision =
    vehicle === CocheTypeEnum.TURISMO
      ? ID_NAVISION_PERMUTAR_TURISMO
      : ID_NAVISION_PERMUTAR_OTHERS

  yield put(
    CestaActions.addProduct(
      {
        id: idNavision,
        type: 'otros',
      },
      'cita-previa'
    )
  )
  yield put(CestaActions.setStep(Steps.TU_SOLICITUD))
  yield navigate(DataSteps[Steps.TU_SOLICITUD].route)
  yield put(PermutarNeumaticosActions.resetPermutarNeumaticos())
}

function* sagas() {
  return all([
    yield takeLatest(
      PermutarNeumaticosActions.PERMUTAR_NEUMATICOS_SET,
      addPermutarNeumaticosCesta
    ),
  ])
}

export default sagas
